// extracted by mini-css-extract-plugin
export default {"container":"app-qualityControl-packetAssignment-modals-ReprioritizeTurfPacketsModal-TurfList-module__psm4Z0Snaxy07cMGxsbd"};